import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@dynamika-shared/ui/Button/Button';
import { twMerge } from '@utils/twMerge';
import { useEffect } from 'react';
import { routesPath } from '@router/routes';

type NotFoundProps = {
  label?: string;
  btnText?: string;
};

export const NotFound: React.FC<NotFoundProps> = ({
  label = 'The page you are looking for doesn\'t exist or has been moved.',
  btnText = 'Home ',
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const handleRedirect = () => {
    navigate(routesPath.home);
  };

  useEffect(() => {
    navigate(routesPath.notFoundRoute);
  }, [location.pathname, navigate]);

  const btnClassNames =
    'border-vermillion bg-vividTangelo transition-colors hover:bg-blue-500 min-w-[14.4rem] rounded-[1.6rem]';

  return (
    <div className='flex h-full flex-col items-center justify-center'>
      <h2 className='text-4xl font-semibold'>
        404{' '}
        <span className='mx-1 my-2 text-[2rem] font-thin text-brightGray'>
          |
        </span>{' '}
        Page Not Found
      </h2>
      <p className='mb-4 mt-2.5 text-1216'>{label}</p>
      <Button
        type='primary'
        className={twMerge(btnClassNames)}
        onClick={() => {
          handleRedirect();
        }}
      >
        <span className='text-1624 font-semibold text-white'>{btnText}</span>
      </Button>
    </div>
  );
};
